module.exports = __webpack_public_path__ + "img/product-not-found.319927f6.png";